document.addEventListener('click', (event) => {
  const quantityButton = event.target.closest('[data-quantity-button]');
  if (!quantityButton) return;

  const input = quantityButton.closest('[data-quantity-input]')?.querySelector('input');
  if (!input) return;

  const step = Number(quantityButton.dataset.quantityButton);
  const currentValue = Number(input.value || 1);
  const nextValue = Math.max(1, currentValue + step);
  input.value = String(nextValue);
});

document.addEventListener('change', (event) => {
  const variantInput = event.target.closest('[data-variant-id]');
  if (!variantInput) return;

  const scope = variantInput.closest('[data-product-root]');
  if (!scope) return;

  const variantIdInput = scope.querySelector('input[name="id"]');
  const priceTarget = scope.querySelector('[data-product-price]');
  const addToCart = scope.querySelector('[data-add-to-cart]');
  const mediaTargets = scope.querySelectorAll('[data-media-id]');

  if (variantIdInput) {
    variantIdInput.value = variantInput.dataset.variantId;
  }

  if (priceTarget) {
    const variantPrice = Number(variantInput.dataset.variantPrice || 0);
    const variantCompare = Number(variantInput.dataset.variantCompare || 0);
    const money = variantInput.dataset.variantMoney || '';
    const compare = variantCompare > variantPrice ? variantInput.dataset.variantCompareMoney : '';
    priceTarget.innerHTML = compare ? `${money} <s>${compare}</s>` : money;
    priceTarget.classList.remove('price--placeholder');
  }

  if (addToCart) {
    const available = variantInput.dataset.variantAvailable === 'true';
    addToCart.disabled = !available;
    addToCart.textContent = available ? 'Add to cart' : 'Sold out';
  }

  mediaTargets.forEach((media) => {
    media.hidden = media.dataset.mediaId !== variantInput.dataset.variantMediaId;
  });
});
